import { render, staticRenderFns } from "./businesslicense.vue?vue&type=template&id=16b541b8&scoped=true"
import script from "./businesslicense.vue?vue&type=script&lang=js"
export * from "./businesslicense.vue?vue&type=script&lang=js"
import style0 from "./businesslicense.vue?vue&type=style&index=0&id=16b541b8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16b541b8",
  null
  
)

export default component.exports